import React from "react";
import PropTypes from "prop-types";
import "./SortableTableRow.css";

const SortableTableHandleHeader = ({ className }) => (
  <th className={[className, "sortable-table-row-handle-cell"].filter(Boolean).join(" ")} aria-label="Reorder" />
);

SortableTableHandleHeader.propTypes = {
  className: PropTypes.string,
};

SortableTableHandleHeader.defaultProps = {
  className: undefined,
};

export default SortableTableHandleHeader;
